import {
  SHAPE_TEXT_INSET_BOTTOM,
  SHAPE_TEXT_INSET_LEFT,
  SHAPE_TEXT_INSET_RIGHT,
  SHAPE_TEXT_INSET_TOP,
} from '@/lib/text/constants/shape-text-insets'

/**
 * A text frame's content inset as a per-side struct — the same universal shape-text inset
 * `getShapeTextFlow` uses for every shape kind (`SHAPE_TEXT_INSET_*`, text-unification Phase 1 D4).
 *
 * Named per side rather than per axis on purpose — axis-named constants invite `padding * 2`, which
 * is wrong here because top and bottom differ.
 */
export const TEXT_BOX_PADDING = {
  top: SHAPE_TEXT_INSET_TOP,
  right: SHAPE_TEXT_INSET_RIGHT,
  bottom: SHAPE_TEXT_INSET_BOTTOM,
  left: SHAPE_TEXT_INSET_LEFT,
} as const
